(function (global) {
    define('LNRS/Components/Forms/SpeakerRequest',[
        "jquery", "vue", "moment", "eventManager", "underscore", "LNRS/Components/Forms/ValidationOptions", "LNRS/Components/Forms/NonEloquaBase", "jqueryValidate", "jqueryUnobtrusiveAjax", "bootstrapSelect", "datetimepicker", "Validation/RecaptchaApiLoader"
    ], function ($, Vue, moment, eventManager, _, vo, neBase) {

        var speakerRequestFormErrorList = [];

        var component = {
            mounted: function () {
                $.validator.setDefaults(vo.getDefaultOptions());
                $.validator.unobtrusive.options = vo.getUnobtrusiveOptions();

                this.formName = "Speaker Request"; // used for analytics
                this.$titleList = $("#Title", this.$el);
                this.$titleList.addClass("form-control").selectpicker("style"); 
                this.$speakerList = $("#RequestedSpeaker", this.$el);
                this.$speakerList.addClass("form-control").selectpicker("style");

                this.initClientValidationEvents();

                $("#EventDate", this.$el).datetimepicker({
                    format: "MM/DD/YYYY",
                    minDate: moment(new Date().getTime()).toDate(),
                    showTodayButton: true,
                    showClear: true,
                    showClose: true
                });

                this.$recaptchaPlaceholders = $(".g-recaptcha", this.$el);
                eventManager.subscribe('RecaptchaApiLoaded', this.onloadRecaptchaCallback.bind(this));

                this.initErrorList();

                this.$result = $("#result-" + this.formId, this.$el);
                this.$form = $("#" + this.formId, this.$el);
                this.$form.validate();

                this.loaded = true;
            },
            computed: {
                disableBtn: function () {
                    return false;
                }
            },
            methods: {
                onloadRecaptchaCallback: function () {
                    neBase.loadRecaptchaCallback(this.$recaptchaPlaceholders, this.recaptchaCallback);
                },
                recaptchaCallback: function () {
                    this.removeErrorFromErrorList("ReCaptcha");
                    var recaptchaErrorLabel = $("label[for='ReCaptcha']", this.$el);
                    if (recaptchaErrorLabel) {
                        recaptchaErrorLabel.remove();
                    }
                },
                removeErrorFromErrorList: function (id) {
                    var errIndex = speakerRequestFormErrorList.indexOf(id);
                    if (errIndex > -1) {
                        speakerRequestFormErrorList.splice(errIndex, 1);
                    }
                },
                onBlur: function (e) {
                    this.validateInput(e.currentTarget, false);
                },
                validateInput: function (e, isForSubmition) {
                    var err = neBase.validateInput(e, isForSubmition);
                    if (err) {
                        neBase.$form.validate().showErrors(err);
                        neBase.trackErrors(this.formName, Object.keys(err).map(function (key) { return err[key]; }));
                    }
                },
                initErrorList: function () {
                    var language = $(this.$form).find("#LanguageName:first").val();
                    if (language !== 'zh-CN') {
                        this.addToErrorList("ReCaptcha");
                    }
                    this.addToErrorList("FirstName");
                    this.addToErrorList("LastName");
                    this.addToErrorList("Organization");
                    this.addToErrorList("EventName");
                    this.addToErrorList("EventLocation");
                    this.addToErrorList("EventTopic");
                    this.addToErrorList("BusinessPhone");
                    this.addToErrorList("EmailAddress");
                    this.addToErrorList("EventDate");
                    this.addToErrorList("Title");
                    this.addToErrorList("RequestedSpeaker");
                },
                addToErrorList: function (id) {
                    var errIndex = speakerRequestFormErrorList.indexOf(id);
                    if (errIndex === -1) {
                        speakerRequestFormErrorList.push(id);
                    }
                },
                initClientValidationEvents: function () {
                    $("#FirstName", this.$el).on("blur", function (e) { this.onBlur(e); }.bind(this));
                    $("#LastName", this.$el).on("blur", function (e) { this.onBlur(e); }.bind(this));
                    $("#Organization", this.$el).on("blur", function (e) { this.onBlur(e); }.bind(this));
                    $("#EventName", this.$el).on("blur", function (e) { this.onBlur(e); }.bind(this));
                    $("#EventDate", this.$el).on("blur", function (e) { this.onBlur(e); }.bind(this));
                    $("#EventLocation", this.$el).on("blur", function (e) { this.onBlur(e); }.bind(this));
                    $("#EventTopic", this.$el).on("blur", function (e) { this.onBlur(e); }.bind(this));
                    $("#BusinessPhone", this.$el).on("blur", function (e) { this.onBlur(e); }.bind(this));
                    $("#EmailAddress", this.$el).on("blur", function (e) { this.onBlur(e); }.bind(this));
                    $("#Title", this.$el).on("hidden.bs.select", function (e) { this.onBlur(e); }.bind(this));
                    $("#RequestedSpeaker", this.$el).on("hidden.bs.select", function (e) { this.onBlur(e); }.bind(this));
                },
                btnClick: function (e) {
                    e.preventDefault();
                    if (!this.loading) {
                        this.submitForm(e);
                    }
                },
                btnBackClick: function (e) {
                    e.preventDefault();
                    this.$result.hide().removeClass("in");
                    this.sent = false;
                    grecaptcha.reset();
                    this.initErrorList();
                    setTimeout(function () {
                        this.$titleList.selectpicker("val", "0").selectpicker("refresh");
                        this.$speakerList.selectpicker("val", "0").selectpicker("refresh");
                    }.bind(this), 200);
                },
                submitForm: function () {
                    this.loading = true;
                    if (speakerRequestFormErrorList.length > 0) {
                        _.each(speakerRequestFormErrorList, function (e) {
                            this.validateInput($("#" + e, this.$el).get(0), true);
                        }.bind(this));
                        this.loading = false;
                        return;
                    }

                    // send all fields, with only yes/no for PII data
                    neBase.trackResponses(this.formName, [
                        "First Name=" + ($("#FirstName", this.$el).val() ? "yes" : "no"),
                        "Last Name=" + ($("#LastName", this.$el).val() ? "yes" : "no"),
                        "Organization=" + $("#Organization", this.$el).val(),
                        "Event Name=" + $("#EventName", this.$el).val(),
                        "Event Date=" + $("#EventDate", this.$el).val(),
                        "Event Location=" + $("#EventLocation", this.$el).val(),
                        "Event Topic=" + $("#EventTopic", this.$el).val(),
                        "Business Phone=" + ($("#BusinessPhone", this.$el).val() ? "yes" : "no"),
                        "Email Address=" + ($("#EmailAddress", this.$el).val() ? "yes" : "no"),
                        "Title=" + $("#Title", this.$el).val(),
                        "Requested Speaker=" + $("#RequestedSpeaker", this.$el).val()
                    ]);

                    $.ajax(neBase.submitObj(this.$form))
                    .fail(function (response) {
                        var errors = neBase.submitFail(response);
                        if (!_.isEmpty(errors)) {
                            this.$form.data("validator").showErrors(errors);
                        }
                    }.bind(this))
                    .always(function (response) {
                        var responseResult = neBase.submitSuccess(response, this.$form, this.$result);
                        this.resultTitle = responseResult.resultTitle;
                        this.resultText = responseResult.resultText;
                        this.sent = responseResult.sent;
                        this.loading = false;
                    }.bind(this));
                }
            }
        };

        return function initSpeakerRequestForm(args) {
            component.el = args.scope;
            component.data = {
                loaded: false,
                formId: args.FormId,
                loading: false,
                sent: false,
                resultTitle: null,
                resultText: null,
                $titleList: null,
                $speakerList: null,
                $recaptchaPlaceholders: null,
                validator: null,
                errorList: [],
                $form: null,
                $result: null
            };
            return args.IsPageEditorEditing === true ? null : new Vue(component);
        };
    });
})(this);
